import React from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Alert from '@mui/material/Alert'

import { SettingsPage } from '@sales-center/components'
import { KnockStatusList } from './KnockStatusList'
import { MapPreview } from './MapPreview'
import { useD2DData } from './hooks/useData'
import { useD2DHandlers } from './hooks/useHandlers'
import { useGetKnockStatusesOnMount } from '@user/store/knockStatus/hooks'
import { AddKnockStatusDialog } from './ManageKnockStatus/AddKnockStatusDialog'
import AlertTitle from '@mui/material/AlertTitle'
import { DeleteKnockStatusDialog } from './ManageKnockStatus/DeleteKnockStatusDialog'

export const DoorToDoor = () => {
  // Fetch statuses on mount
  useGetKnockStatusesOnMount()

  const { allStatuses, isAtLimit } = useD2DData()
  const {
    addDialogOpen,
    addDialogDeleteOpen,
    editStatusId,
    deleteStatusId,
    handleOpenAddDialog,
    handleOpenEditDialog,
    handleCloseDialog,
    handleOpenDeleteDialog,
  } = useD2DHandlers()

  return (
    <SettingsPage padding="0">
      <Box maxWidth={800} mx="auto" mt="80px" p={2}>
        <Paper sx={{ p: '16px', mb: 2 }} variant="outlined">
          <Typography variant="h5">Door to Door Sales</Typography>
          <Typography variant="body2">
            Unlock powerful territorial management and field sales tracking
            capabilities for your team.
          </Typography>
        </Paper>

        <Paper sx={{ p: '16px', mb: 2 }} variant="outlined">
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            mb={2}
            gap="20px"
          >
            <Stack>
              <Typography variant="subtitle3" mb={'12px'}>
                Manage Knock Statuses
              </Typography>
              {!isAtLimit && (
                <Typography variant="body2">
                  Set up and manage knock statuses and other configurations. Add
                  up to 4 additional statuses.
                </Typography>
              )}
            </Stack>

            <Button
              onClick={handleOpenAddDialog}
              disabled={isAtLimit}
              variant="contained"
              color="primary"
              sx={{ minWidth: 150 }}
              data-test-id="addKnockStatusBtn"
            >
              Add Knock Status
            </Button>
          </Stack>

          {isAtLimit && (
            <Alert severity="info" sx={{ alignItems: 'flex-start', mb: 3 }}>
              <AlertTitle>
                <Typography
                  variant="subtitle1"
                  sx={{
                    lineHeight: '24px',
                    fontWeight: '600',
                  }}
                  color={'#22548C'}
                >
                  Knock status limit reached
                </Typography>
              </AlertTitle>
              You can create up to 4 knock statuses. To add a new one, edit or
              delete an existing status.
            </Alert>
          )}

          <KnockStatusList
            statuses={allStatuses}
            onEdit={handleOpenEditDialog}
            onDelete={handleOpenDeleteDialog}
          />
        </Paper>

        <Paper sx={{ p: '16px', mb: 2 }} variant="outlined">
          <MapPreview statuses={allStatuses} />
        </Paper>
      </Box>

      <AddKnockStatusDialog
        open={addDialogOpen}
        onClose={handleCloseDialog}
        editId={editStatusId}
      />

      <DeleteKnockStatusDialog
        open={addDialogDeleteOpen}
        onClose={handleCloseDialog}
        id={deleteStatusId}
      />
    </SettingsPage>
  )
}
